import Card from "../UI/Card";
import Text from "../UI/Text";
import Title from "../UI/Title";
import ModalDialog from "../UI/ModalDialog";
import PretTable from "./PretTable.tsx";
// @ts-expect-error pure js
import { currencyFormatter, dateConvert } from "../../api/Functions";
import type { TableauAmortissement } from "../../models/tableauAmortissement";
import styles from "./PretDetailView.module.css";

interface PretDetailViewProps {
  tableau: TableauAmortissement;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function PretDetailView({
  tableau,
  open,
  onOpenChange,
}: PretDetailViewProps) {
  const { contenu = [] } = tableau;

  const totals = contenu.reduce(
    (acc, ligne) => ({
      capital: acc.capital + (ligne.capital || 0),
      interets: acc.interets + (ligne.interets || 0),
      assurance: acc.assurance + (ligne.assurance || 0),
      frais_dossier: acc.frais_dossier + (ligne.frais_dossier || 0),
      mensualite: acc.mensualite + (ligne.mensualite_totale || 0),
    }),
    { capital: 0, interets: 0, assurance: 0, frais_dossier: 0, mensualite: 0 },
  );

  return (
    <ModalDialog
      open={open}
      onOpenChange={onOpenChange}
      size="xl"
      header={<Title variant="mega">{tableau.nom}</Title>}
    >
      <div className={styles.metadata}>
        <Card padding="sm" className={styles.metaGrid}>
          <div>
            <Text color="muted">Montant emprunté</Text>
            <Text weight="bold">
              {tableau.montant_total
                ? currencyFormatter(tableau.montant_total)
                : "-"}
            </Text>
          </div>
          <div>
            <Text color="muted">Taux d'intérêt</Text>
            <Text weight="bold">
              {tableau.taux_nominal ? `${tableau.taux_nominal}%` : "-"}
            </Text>
          </div>
          <div>
            <Text color="muted">Durée</Text>
            <Text weight="bold">
              {tableau.duree_mois ? `${tableau.duree_mois} mois` : "-"}
            </Text>
          </div>
          <div>
            <Text color="muted">Date de début</Text>
            <Text weight="bold">
              {tableau.date_debut ? dateConvert(tableau.date_debut) : "-"}
            </Text>
          </div>
        </Card>

        <Card padding="sm" className={styles.metaGrid}>
          <div>
            <Text color="muted">Total capital remboursé</Text>
            <Text weight="bold">{currencyFormatter(totals.capital)}</Text>
          </div>
          <div>
            <Text color="muted">Total intérêts</Text>
            <Text weight="bold">{currencyFormatter(totals.interets)}</Text>
          </div>
          <div>
            <Text color="muted">Total assurance</Text>
            <Text weight="bold">{currencyFormatter(totals.assurance)}</Text>
          </div>
          <div>
            <Text color="muted">Frais de dossier</Text>
            <Text weight="bold">{currencyFormatter(totals.frais_dossier)}</Text>
          </div>
          <div>
            <Text color="muted">Coût total du crédit</Text>
            <Text weight="bold">
              {currencyFormatter(
                totals.interets + totals.assurance + totals.frais_dossier,
              )}
            </Text>
          </div>
        </Card>
      </div>

      <div>
        <Title variant="kilo">
          Tableau d'amortissement ({contenu.length} échéances)
        </Title>
        <PretTable lignes={contenu} />
      </div>
    </ModalDialog>
  );
}
